import { Component, OnInit } from '@angular/core';
import { BillboardService } from '../billboard-service/billboard.service';

import { Billboard } from '../billboard.interface';

@Component({
	selector: 'eze-billboard',
	templateUrl: './billboard.component.html',
	styleUrls: ['./billboard.component.css']
})
export class BillboardComponent implements OnInit {
	billboard: Billboard = { black: '', color: '', rings: [] };

	constructor(private billboardService: BillboardService) {}

	ngOnInit() {
		this.getBillboardData();
		setInterval(() => {
			this.getBillboardData();
		}, 5000);
	}

	getBillboardData() {
		this.billboardService.getBillboardData().subscribe(
			(res: Billboard) => {
				this.billboard = res;
			},
			err => {
				console.log('err =', err);
			}
		);
	}

	get numRings() {
		return this.billboard.rings.length;
	}

	get halfRings() {
		return Math.floor(this.numRings / 2);
	}

	get leftRings() {
		return this.billboard.rings.slice(0, this.halfRings);
	}

	get rightRings() {
		return this.billboard.rings.slice(
			this.halfRings,
			this.billboard.rings.length
		);
	}
}
